/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DisplayListingLocationAvailability,
  MembershipModel,
  MembershipPackageDiscount,
  MembershipRewardGroupModel
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get a list of memberships available to the user and platform
 */
export const getMemberships = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MembershipModel[]>(
      {url: `/api/v1/memberships`, method: 'GET', signal
    },
      options);
    }




export const getGetMembershipsQueryKey = () => {
    return [
    `/api/v1/memberships`
    ] as const;
    }


export const getGetMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberships>>> = ({ signal }) => getMemberships(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberships>>>
export type GetMembershipsQueryError = ErrorType<unknown>


export function useGetMemberships<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberships>>,
          TError,
          Awaited<ReturnType<typeof getMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberships<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberships>>,
          TError,
          Awaited<ReturnType<typeof getMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberships<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a list of memberships available to the user and platform
 */

export function useGetMemberships<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembershipsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get a specific membership
 */
export const getMembership = (
    membershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MembershipModel>(
      {url: `/api/v1/memberships/${membershipId}`, method: 'GET', signal
    },
      options);
    }




export const getGetMembershipQueryKey = (membershipId: string,) => {
    return [
    `/api/v1/memberships/${membershipId}`
    ] as const;
    }


export const getGetMembershipQueryOptions = <TData = Awaited<ReturnType<typeof getMembership>>, TError = ErrorType<unknown>>(membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembership>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipQueryKey(membershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembership>>> = ({ signal }) => getMembership(membershipId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: membershipId !== null && membershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembership>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembershipQueryResult = NonNullable<Awaited<ReturnType<typeof getMembership>>>
export type GetMembershipQueryError = ErrorType<unknown>


export function useGetMembership<TData = Awaited<ReturnType<typeof getMembership>>, TError = ErrorType<unknown>>(
 membershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembership>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembership>>,
          TError,
          Awaited<ReturnType<typeof getMembership>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembership<TData = Awaited<ReturnType<typeof getMembership>>, TError = ErrorType<unknown>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembership>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembership>>,
          TError,
          Awaited<ReturnType<typeof getMembership>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembership<TData = Awaited<ReturnType<typeof getMembership>>, TError = ErrorType<unknown>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembership>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific membership
 */

export function useGetMembership<TData = Awaited<ReturnType<typeof getMembership>>, TError = ErrorType<unknown>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembership>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembershipQueryOptions(membershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Membership reads are scoped to the patient's own location, so a shared link to one sold
 * elsewhere resolves to a bare not-found. This says where it is sold, so the app can offer
 * to switch location instead of dead-ending.
 * @summary Returns the locations a membership is purchasable at.
 */
export const getMembershipLocationAvailability = (
    membershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayListingLocationAvailability>(
      {url: `/api/v1/memberships/${membershipId}/location-availability`, method: 'GET', signal
    },
      options);
    }




export const getGetMembershipLocationAvailabilityQueryKey = (membershipId: string,) => {
    return [
    `/api/v1/memberships/${membershipId}/location-availability`
    ] as const;
    }


export const getGetMembershipLocationAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError = ErrorType<void>>(membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipLocationAvailabilityQueryKey(membershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembershipLocationAvailability>>> = ({ signal }) => getMembershipLocationAvailability(membershipId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: membershipId !== null && membershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembershipLocationAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getMembershipLocationAvailability>>>
export type GetMembershipLocationAvailabilityQueryError = ErrorType<void>


export function useGetMembershipLocationAvailability<TData = Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError = ErrorType<void>>(
 membershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembershipLocationAvailability>>,
          TError,
          Awaited<ReturnType<typeof getMembershipLocationAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembershipLocationAvailability<TData = Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError = ErrorType<void>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembershipLocationAvailability>>,
          TError,
          Awaited<ReturnType<typeof getMembershipLocationAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembershipLocationAvailability<TData = Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError = ErrorType<void>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the locations a membership is purchasable at.
 */

export function useGetMembershipLocationAvailability<TData = Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError = ErrorType<void>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipLocationAvailability>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembershipLocationAvailabilityQueryOptions(membershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get the list of membership rewards tied to a specific membership
 */
export const getMembershipRewards = (
    membershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MembershipRewardGroupModel[]>(
      {url: `/api/v1/memberships/${membershipId}/rewards`, method: 'GET', signal
    },
      options);
    }




export const getGetMembershipRewardsQueryKey = (membershipId: string,) => {
    return [
    `/api/v1/memberships/${membershipId}/rewards`
    ] as const;
    }


export const getGetMembershipRewardsQueryOptions = <TData = Awaited<ReturnType<typeof getMembershipRewards>>, TError = ErrorType<unknown>>(membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipRewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipRewardsQueryKey(membershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembershipRewards>>> = ({ signal }) => getMembershipRewards(membershipId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: membershipId !== null && membershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembershipRewards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembershipRewardsQueryResult = NonNullable<Awaited<ReturnType<typeof getMembershipRewards>>>
export type GetMembershipRewardsQueryError = ErrorType<unknown>


export function useGetMembershipRewards<TData = Awaited<ReturnType<typeof getMembershipRewards>>, TError = ErrorType<unknown>>(
 membershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipRewards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembershipRewards>>,
          TError,
          Awaited<ReturnType<typeof getMembershipRewards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembershipRewards<TData = Awaited<ReturnType<typeof getMembershipRewards>>, TError = ErrorType<unknown>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipRewards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembershipRewards>>,
          TError,
          Awaited<ReturnType<typeof getMembershipRewards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembershipRewards<TData = Awaited<ReturnType<typeof getMembershipRewards>>, TError = ErrorType<unknown>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipRewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the list of membership rewards tied to a specific membership
 */

export function useGetMembershipRewards<TData = Awaited<ReturnType<typeof getMembershipRewards>>, TError = ErrorType<unknown>>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipRewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembershipRewardsQueryOptions(membershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get membership discount prices for packages available to the user
 */
export const getMembershipDiscountPrices = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MembershipPackageDiscount[]>(
      {url: `/api/v1/memberships/discount-prices`, method: 'GET', signal
    },
      options);
    }




export const getGetMembershipDiscountPricesQueryKey = () => {
    return [
    `/api/v1/memberships/discount-prices`
    ] as const;
    }


export const getGetMembershipDiscountPricesQueryOptions = <TData = Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipDiscountPricesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembershipDiscountPrices>>> = ({ signal }) => getMembershipDiscountPrices(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembershipDiscountPricesQueryResult = NonNullable<Awaited<ReturnType<typeof getMembershipDiscountPrices>>>
export type GetMembershipDiscountPricesQueryError = ErrorType<unknown>


export function useGetMembershipDiscountPrices<TData = Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembershipDiscountPrices>>,
          TError,
          Awaited<ReturnType<typeof getMembershipDiscountPrices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembershipDiscountPrices<TData = Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembershipDiscountPrices>>,
          TError,
          Awaited<ReturnType<typeof getMembershipDiscountPrices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembershipDiscountPrices<TData = Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get membership discount prices for packages available to the user
 */

export function useGetMembershipDiscountPrices<TData = Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembershipDiscountPrices>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembershipDiscountPricesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






